/* @flow */

import React, { Fragment } from 'react';
import { injectIntl } from 'react-intl';
import classnames from 'classnames';
import stepPreferenceStyles from '../styles/FormStepPreference.scss';
import formStyles from '../styles/FormGeneral.scss';
import { ErrorMessage } from './ErrorMessage';
import { SubText } from './SubText';

const position = [
    stepPreferenceStyles.radioWrapperLeft,
    stepPreferenceStyles.radioWrapperCenter,
    stepPreferenceStyles.radioWrapperRight,
];
type Props<T> = {|
    intl: intlShape,
    scrollId: string,
    buttons: Array<$Keys<T>>,
    pictureLeft: Element,
    pictureRight: Element,
    selected: string,
    label: T,
    onChange: string => void,
    error: string,
    question: Element,
    bottomText?: Element,
|};
export const RadioBarComponent = <T: Object>(props: Props<T>) => (
    <Fragment>
        <div className={formStyles.divider} />
        <div className={formStyles.contentWrapper}>
            <div id={props.scrollId} className={stepPreferenceStyles.item}>
                <SubText text={props.question} />
                <div className={stepPreferenceStyles.iconRow}>
                    {props.pictureLeft}
                    {props.pictureRight}
                </div>
                <div className={stepPreferenceStyles.radioRowDiv}>
                    {props.buttons.map((option, index) => {
                        const optionValue = props.intl.formatMessage(props.label[option]);
                        const optionPosition = position[index];
                        const styleButton =
                            props.selected === option
                                ? stepPreferenceStyles.selected
                                : stepPreferenceStyles.empty;
                        return (
                            <div
                                className={optionPosition}
                                onClick={() => {
                                    props.onChange(option);
                                }}
                                key={option}
                            >
                                <div
                                    className={classnames(stepPreferenceStyles.button, styleButton)}
                                />
                                <div className={stepPreferenceStyles.label}> {optionValue}</div>
                            </div>
                        );
                    })}
                    <div className={stepPreferenceStyles.radioBackground} />
                </div>
                <ErrorMessage errors={props.error} />
                {props.bottomText}
            </div>
        </div>
    </Fragment>
);

export const RadioBar = injectIntl(RadioBarComponent);
